import { Empty, Id, MenuTreeView, TreeItem } from "@dgs/core";
import { useQuery } from "@tanstack/react-query";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { bottomNavBarItemService } from "../shared/api/bottomNavBarService";
import { BottomNavBarItemIndexResource } from "../shared/types/bottomNavBarItem";

const mapToTreeItem = (navBarItem: BottomNavBarItemIndexResource): TreeItem => {
	return {
		id: navBarItem.id,
		text: navBarItem.name,
		children: [],
		canHaveChildren: false,
	};
};

interface Props {
	onEdit: (id: Id) => void;
	onDelete: (id: Id) => void;
	onReorder: (orderedIds: Id[]) => void;
}

export const BottomNavBarItemList: FC<Props> = ({ onEdit, onDelete, onReorder }) => {
	const { t } = useTranslation();
	const { data: bottomNavBarTreeItems } = useQuery({
		queryKey: [...bottomNavBarItemService.indexKey, "tree"],
		queryFn: () => bottomNavBarItemService.index().then(({ data }) => data.data.map(mapToTreeItem)),
	});

	if (!bottomNavBarTreeItems) {
		return <Empty>{t("No nav bar items available.")}</Empty>;
	}

	return (
		<MenuTreeView
			menuItems={bottomNavBarTreeItems}
			onDrop={(items) => onReorder(items.map(({ id }) => id))}
			onEdit={onEdit}
			onDelete={onDelete}
		/>
	);
};
